// src/components/PostHog/posthog.js
import posthog from 'posthog-js';

class PostHogService {
  constructor() {
    this.isInitialized = false;
  }

  init() {
    if (typeof window !== 'undefined' && !this.isInitialized) {
      posthog.init(
        process.env.REACT_APP_POSTHOG_KEY || 'YOUR_API_KEY',
        {
          api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
          capture_exceptions: true, // This enables capturing exceptions using Error Tracking
          debug: process.env.NODE_ENV === 'development',
          person_profiles: 'identified_only' // Creates profiles only for identified users
        }
      );
      this.isInitialized = true;
    }
  }

  // Track events
  capture(event, properties = {}) {
    if (this.isInitialized && posthog.__loaded) {
      posthog.capture(event, properties);
    }
  }

  // Identify users (creates a person profile)
  identify(userId, properties = {}) {
    if (this.isInitialized && posthog.__loaded) {
      posthog.identify(userId, properties);
    }
  }

  // Set user properties
  setPersonProperties(properties) {
    if (this.isInitialized && posthog.__loaded) {
      posthog.setPersonProperties(properties);
    }
  }

  // Track page views manually (useful for SPAs)
  pageView(path) {
    if (this.isInitialized && posthog.__loaded) {
      posthog.capture('$pageview', { $current_url: path });
    }
  }

  // Reset user session (on logout)
  reset() {
    if (this.isInitialized && posthog.__loaded) {
      posthog.reset();
    }
  }

  // Feature flags
  isFeatureEnabled(flag) {
    if (this.isInitialized && posthog.__loaded) {
      return posthog.isFeatureEnabled(flag);
    }
    return false;
  }

  // Get feature flag value
  getFeatureFlag(flag) {
    if (this.isInitialized && posthog.__loaded) {
      return posthog.getFeatureFlag(flag);
    }
    return null;
  }

  // Check if PostHog is ready to use
  isReady() {
    return this.isInitialized && posthog.__loaded;
  }
}

// Create singleton instance
const posthogService = new PostHogService();

export default posthogService;
